import { useNavigate } from 'react-router-dom';

const STATS = [
  { value: '110+', label: 'Dự Án Hoàn Thành' },
  { value: '2–5×', label: 'Tăng Hiệu Quả Tài Sản' },
  { value: '90%', label: 'Khách Hàng Hài Lòng' },
  { value: '10+', label: 'Năm Kinh Nghiệm' },
];

export default function HeroSection() {
  const navigate = useNavigate();

  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative min-h-screen flex flex-col justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/08ee924776e850eba2249c157fea442c.jpg"
          alt="Nhà phố nội đô TP.HCM"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#002626]/90 via-[#003333]/75 to-[#004D4D]/50" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#001A1A]/80 via-transparent to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-8 pt-32 pb-16">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-[#C5A059]/20 border border-[#C5A059]/40 text-[#C5A059] text-xs font-semibold tracking-widest uppercase px-4 py-2 rounded-full mb-8 font-heading">
            <span className="w-1.5 h-1.5 rounded-full bg-[#C5A059] animate-pulse" />
            Asset Model Company — TP.HCM
          </div>

          {/* Headline */}
          <h1 className="font-heading font-extrabold text-4xl md:text-5xl lg:text-6xl text-white leading-tight mb-6">
            Tài sản của bạn<br />
            <span className="text-[#C5A059]">đang sinh lời</span><br />
            chưa tối đa?
          </h1>

          {/* Sub */}
          <p className="text-white/80 text-lg md:text-xl font-sans font-light leading-relaxed mb-10 max-w-xl">
            Hầu hết chủ nhà đang để tài sản hoạt động dưới <strong className="text-[#C5A059] font-semibold">50% tiềm năng</strong> — UPLIVING giúp bạn thay đổi điều đó trong 3–6 tháng
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 mb-16">
            <button
              onClick={() => navigate('/bat-mach-tai-san')}
              className="bg-[#C5A059] hover:bg-[#D4B575] text-[#002626] font-heading font-bold text-base px-8 py-4 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Bắt Mạch Tài Sản Miễn Phí →
            </button>
            <button
              onClick={() => navigate('/du-an')}
              className="bg-white/10 hover:bg-white/20 border border-white/30 text-white font-heading font-semibold text-base px-8 py-4 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer backdrop-blur-sm"
            >
              Xem Dự Án Thực Tế
            </button>
          </div>

          {/* Core Message */}
          <div className="border-l-2 border-[#C5A059] pl-5">
            <p className="text-white/60 text-sm font-sans italic">
              "Không có nhà kém — chỉ có tài sản đang bị dùng sai mô hình"
            </p>
          </div>
        </div>

        {/* Stats Bar */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10 rounded-2xl overflow-hidden border border-white/10">
          {STATS.map((stat) => (
            <div key={stat.value} className="bg-white/5 backdrop-blur-sm px-6 py-6 text-center">
              <div className="font-heading font-extrabold text-3xl text-[#C5A059] mb-1">{stat.value}</div>
              <div className="text-white/60 text-xs font-sans tracking-wide">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <button
        onClick={() => scrollToSection('insight')}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 text-white/40 hover:text-[#C5A059] transition-colors cursor-pointer w-10 h-10 flex items-center justify-center animate-bounce"
      >
        <i className="ri-arrow-down-line text-2xl" />
      </button>
    </section>
  );
}
